import { useCallback, useState } from "react";

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const PHONE_REGEX = /^\+?[0-9]{7,15}$/;
const EMERGENCY_CONTACT_REGEX = /^.*\+?[0-9]{7,15}.*$/;

const useStudentFormValidation = () => {
  const [formErrors, setFormErrors] = useState({});

  const clearFieldError = useCallback((field) => {
    setFormErrors((prev) => {
      if (!prev[field]) return prev;
      const nextErrors = { ...prev };
      delete nextErrors[field];
      return nextErrors;
    });
  }, []);

  const resetErrors = useCallback(() => {
    setFormErrors({});
  }, []);

  const validateForm = useCallback((formState) => {
    const errors = {};

    if (!formState.name?.trim()) {
      errors.name = "Full name is required.";
    } else if (formState.name.trim().length <= 2) {
      errors.name = "Full name must be greater than 2 characters.";
    }

    const trimmedEmail = formState.email?.trim();
    if (!trimmedEmail) {
      errors.email = "Email address is required.";
    } else if (!EMAIL_REGEX.test(trimmedEmail)) {
      errors.email = "Enter a valid email address.";
    }

    if (formState.phone_number?.trim()) {
      const normalizedPhone = formState.phone_number.trim();
      if (!PHONE_REGEX.test(normalizedPhone)) {
        errors.phone_number =
          "Enter a valid phone number (7-15 digits, optional leading +).";
      }
    }

    if (formState.emergency_contact?.trim()) {
      const normalizedContact = formState.emergency_contact.trim();
      if (!EMERGENCY_CONTACT_REGEX.test(normalizedContact)) {
        errors.emergency_contact =
          "Emergency contact must include a valid phone number.";
      }
    }

    if (
      formState.graduation_year !== "" &&
      formState.graduation_year !== null &&
      formState.graduation_year !== undefined
    ) {
      const yearString = String(formState.graduation_year).trim();
      const year = Number(yearString);
      const currentYear = new Date().getFullYear();

      if (!/^\d{4}$/.test(yearString)) {
        errors.graduation_year =
          "Graduation year must be a 4 digit number.";
      } else if (year <= 1950) {
        errors.graduation_year =
          "Graduation year must be after 1950.";
      } else if (year > currentYear) {
        errors.graduation_year =
          "Graduation year cannot be in the future.";
      }
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  }, []);

  return {
    formErrors,
    validateForm,
    clearFieldError,
    resetErrors,
  };
};

export default useStudentFormValidation;

